import Popup from 'components/controls/PopUp/PopUp';
import React, { useState } from 'react';
import './../controls/PopUp/PopUp.scss'

const WelcomePopUp: React.FC = () => {

    const [show, setShow] = useState(true);

    const title = "ברוכים הבאים";
    const body = (
        <div dir="rtl">
            <h6 className='bold'>למערכת החדשה להצגת נתוני התלונות שהתקבלו או שטופלו בנציבות תלונות הציבור</h6>
            <p>
                אנו שמחים להציג את מערכת המידע בינה עסקית (BI) של נציבות תלונות הציבור. המערכת מאפשרת לקבל נתונים שוטפים על התלונות שהתקבלו או שטופלו בנציבות, והיא מתעדכנת בכל יום עבודה.
            </p>
            <p>אלו הנתונים שתוכלו למצוא:</p>
            <ul>
                <li>מספר התלונות שהנציבות קיבלה</li>
                <li>מספר התלונות שהנציבות טיפלה בהם</li>
                <li>תוצאות הטיפול בתלונות</li>
                <li>הגופים שעליהם התבררו תלונות ובכלל זה רשויות מקומיות</li>
                <li>נושאי התלונה המובילים</li>
                <li>התפלגות המתלוננים לפי מגדר</li>
                <li>התפלגות התלונות לפי מקום המגורים ומחוז המגורים של המתלוננים </li>
            </ul>
            <p>
                הערה - הנתונים הרשמיים מובאים בדוח השנתי של נציב תלונות הציבור, ותיתכן שונות בין הנתונים המוצגים בו לנתונים המוצגים במערכת. המידע בפילוחים השונים יוצג אם מספר המופעים יהיה 5 ומעלה.
            </p>
            <p>
                בבחירת הצגת נתוני השנה הנוכחית, שטרם הסתיימה, המערכת מציגה את הנתונים החלקיים של שנה זו לעומת הנתונים המלאים של השנה הקודמת.
            </p>
        </div>
    );

    return <Popup title={title} body={body} show={show} setShow={setShow}/>;
};

export default WelcomePopUp;
